import { QuoteService } from 'quote-domain-core';
import { AbstractPriceEngineCalculator } from '../abstract-price-engine-calculator';
import { VtCorridorCalculationService } from './vt-corridor-calculation-service';
import {singleton} from "tsyringe";

@singleton()
export class VtCorridorCalculator extends AbstractPriceEngineCalculator {

    constructor(quoteService: QuoteService, referential: any, referentialService: any, region: string, private readonly corridorCalculationService: VtCorridorCalculationService) {
        super(quoteService, referential, referentialService, region);
    }

    execute(): void {
        this.corridorCalculationService.calculate(this.quoteService, this.referential, this.referentialService, this.region);
    }
}
